import React 			from 'react';
import PropTypes 	from 'prop-types';

import BLComponent from '../core/_BLComponent.jsx';

// this.props.status: integer of which pill to use 0-5
// this.props.remainingQty: (optional unless status is 0) integer of remaining qty

export default class PillStatus extends BLComponent {
	constructor(props) {
		super(props);

		this.pillTypes = [
				{text: $T('LEFT'), className: 'pill--limited-remaining'}
			,	{text: $T('SOON'), className: 'pill--not-available'}
			,	{text: $T('SOLD_OUT'), className: 'pill--not-available'}
			,	{text: $T('OUT_OF_STOCK'), className: 'pill--not-available'}
			,	{text: $T('RARE'), className: 'pill--rare'}
			,	{text: $T('AVAILABLE'), className: 'pill--available'}
		];
	}

	render() {
		const {status, remainingQty} = this.props;

		// for development
		// const type = pillTypes[Math.floor(Math.random() * pillTypes.length)];
		const type = this.pillTypes[status];

		return (
			<div className={"pill pill--medium " + type.className}>
				{status == 0 ? remainingQty : null} {type.text}
			</div>
		);
	}
}

PillStatus.propTypes = {
		status: PropTypes.oneOf([0, 1, 2, 3, 4, 5])
	, remainingQty: function(props, propName, componentName) {
			if(props['status'] === 0 && props[propName] == undefined) return new Error('You must provide a remainingQty when having a status of 0')
		}
};



var $T = BLComponent.createTextMap( 
		{
			"LEFT":
			{
				"en":	"left"
			,	"kr":	""
			,	"es":	"restantes"
			}
		, "SOON":
				{
					"en": "Coming soon"
				,	"kr": ""
				,	"es": "Próximamente"
				}
		, "SOLD_OUT":
				{
					"en": "Sold out"
				,	"kr": ""
				,	"es": "Vendido"
				}
		, "OUT_OF_STOCK":
				{
					"en": "Out of stock"
				,	"kr": ""
				,	"es": "Agotado"
				}
		, "RARE":
				{
					"en": "Rare find"
				,	"kr": ""
				,	"es": "Hallazgo curioso"
				}
		, "AVAILABLE":
				{
					"en": "Now available"
				,	"kr": ""
				,	"es": "Disponible"
				}
		
	}
);